import { useRef, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { withRouter } from 'next/router'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'

import API from 'api'
import {
  nationalPhoneNumber,
  internationalPhoneNumber,
} from 'helpers/phoneFormat'
import { showBasicModal } from 'helpers/modal'
import { useTranslation } from 'i18n-web/i18next'

import PhoneNumber from './Screen'

const FormikHOC = ({ token, ...props }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const country = useSelector(state => state.countries.country)
  const user = useSelector(state => state.user.me)
  const isSDK = useSelector(state => state.settings.isSDK)
  const [currentCountryCode, setCurrentCountryCode] = useState(country)
  const formikRef = useRef()

  const initialValues = { phoneNumber: '' }

  useEffect(() => {
    setCurrentCountryCode(country)
  }, [country])

  useEffect(() => {
    if (formikRef.current && user) {
      formikRef.current.setFieldValue(
        'phoneNumber',
        internationalPhoneNumber(user.phoneNumber, user.phoneCountryCode)
      )
    }
    if (!isEmpty(user.phoneCountryCode)) {
      setCurrentCountryCode(user.phoneCountryCode)
    }
  }, [user, formikRef])

  const handleSubmit = (values, { setSubmitting }) => {
    setSubmitting(true)

    const phoneNumber = nationalPhoneNumber(
      values.phoneNumber,
      currentCountryCode
    )

    API()
      .magicLink({
        ...(isSDK && { sdk: true }),
        body: JSON.stringify({
          messageContext: 'download_pay_for_parking',
          sendTextMessage: true,
          phoneNumber: phoneNumber,
          phoneCountryCode: country,
          originalDeepLinkToken: token,
        }),
      })
      .then(resp => {
        setSubmitting(false)
        if (!resp.error) {
          dispatch(
            showBasicModal({
              title: t('downloadApp.default.success.title'),
              description: t('downloadApp.default.success.description'),
            })
          )
        } else {
          dispatch(
            showBasicModal({
              title: t('downloadApp.default.error.title'),
              description: t('downloadApp.default.error.description'),
            })
          )
        }
      })
  }

  const onFocusField = (setSubmitting, setStatus) => {
    setSubmitting(false)
    setStatus(null)
  }

  return (
    <PhoneNumber
      handleSubmit={handleSubmit}
      initialValues={initialValues}
      onFocusField={onFocusField}
      country={country}
      formikRef={formikRef}
      t={t}
      {...props}
    />
  )
}

FormikHOC.propTypes = {
  token: PropTypes.string,
}

export default withRouter(FormikHOC)
